import { useContext } from 'react';
import { OrderStatusCard, StatusCardType } from '@/common/OrderStatusCard';
import OrderState from '~/constants/home/orderState';
import UserPurchaseContext from '~/context/home/UserPurchaseContext';
import ErrorBoundary from '~/utilities/ErrorBoundary';

export default function OrderStatusCardMapper() {
  const {
    userPurchase: {
      data: { orderState, vehicle, openVerifications }
    }
  } = useContext(UserPurchaseContext);

  let cardType: StatusCardType;

  switch (orderState) {
    case OrderState.OrderPlaced:
      cardType = StatusCardType.OrderPlaced;
      break;

    case OrderState.InProgress:
    case OrderState.InProgressWithTradeIn:
      cardType = StatusCardType.PurchaseInProgress;
      break;

    case OrderState.RecentlyPurchased:
      cardType = StatusCardType.Purchased;
      break;

    case OrderState.Reserved:
      cardType = StatusCardType.Reserved;
      break;

    default:
      return null;
  }

  return (
    <ErrorBoundary key={cardType}>
      <OrderStatusCard
        cardStatus={cardType}
        orderState={orderState}
        vehicle={vehicle}
        openVerifications={openVerifications}
        nativeSource="home"
      />
    </ErrorBoundary>
  );
}
